import React from 'react';
import { Table } from 'antd';
import { PageContainer, PageContent } from 'app/components/common'; 
import { InfoBlock } from 'app/components/common';
 import { Translate } from '../../../services';  
import { cookieHeaders, cookieTables } from './cookieData';
import './styles.less';

export const CookiePolicyPage = ( props ) => {  
 
    return (
        <PageContent className="page-cookie-policy">
            <PageContainer>
                <h1>
                    <Translate.Text
                        value="page.cookiePolicy.headers.cookiePolicy"
                    />
                </h1>

                <InfoBlock> 
                    <InfoBlock.Header divider={ false }>
                        <Translate.Text
                            value="page.cookiePolicy.sections.whyCookies.header" 
                        />
                    </InfoBlock.Header>
                      
                    <InfoBlock.Body>
                        <Translate.Text 
                            value="page.cookiePolicy.sections.whyCookies.body" 
                        />
                    </InfoBlock.Body>
                </InfoBlock>

                <InfoBlock> 
                    <InfoBlock.Header divider={ false }>
                        <Translate.Text
                            value="page.cookiePolicy.cookieTable.title.essential" 
                        />
                    </InfoBlock.Header>
                      
                    <InfoBlock.Body>
                        <Table 
                            className="striped-rows non-compact" 
                            dataSource={ cookieTables } 
                            columns={ cookieHeaders }
                            pagination= { {
                                hideOnSinglePage: true
                            } }
                        />
                        <div className="compact">
                            {
                                cookieTables.map( c => (
                                    <div className='cookie-section' key={ c.key }>
                                        {
                                            cookieHeaders.map( h => (
                                                <div className='cookie-subsection' key={ h.key }>
                                                    <span>{ h.title }</span>
                                                    <span>{ h.render( c[ h.dataIndex ] ) }</span>
                                                </div>
                                            ) )
                                        }
                                    </div>
                                ) )
                            }
                        </div>
                    </InfoBlock.Body>
                </InfoBlock>
            </PageContainer>
        </PageContent>
    );
};
